export * from './getaway-traveling-info-wrapper';
